import CrudApi from './crud';
import http from './http';

export function attachMedia(taskId, mediaId, conf) {
	return http.post(`/admin/tasks/${taskId}/media/${mediaId}`, { conf }).then(resp => resp.data);
}

export function detachMedia(taskId, mediaId) {
	return http.delete(`/admin/tasks/${taskId}/media/${mediaId}`).then(resp => resp.data);
}

export const crud = new CrudApi('/admin/tasks', { only: ['index', 'show', 'update', 'store'] });

export const analysisCrud = new CrudApi('/admin/taskanalysis', { only: ['index'] });

export function getTaskLink(taskId) {
	return http.get(`/admin/taskanalysis/link/${taskId}`).then(resp => resp.data);
}
export function toggleTaskStatChecked(taskId) {
	return http.get(`/admin/taskanalysis/togglechecked/${taskId}`).then(resp => resp.data);
}
export function getResults(taskIds) {
	return http.post('/admin/taskanalysis/results', { taskIds }).then(resp => resp.data);
}
export function recalculateResults(taskIds) {
	return http.post('/admin/taskanalysis/recalculate', { taskIds }).then(resp => resp.data);
}
